import { CompanySalesSettings } from '../modules/sales/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanySalesSettingsScreen() {
  const { can, company } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('sales.settings.manage')}>
      <CompanySalesSettings units={company.businessUnits ?? []} />
    </GatedCompanyScreen>
  );
}
